<template>
<!-- <div><br> -->
<!-- <div style="margin-top:20px; text-align:justify;" v-if="activo==0"> -->
  <div class="columns">
    <div class="column is-9" style="margin-left:10px;">
    <h2> Términos y condiciones. </h2>

    <br><br>
    Las imágenes, videos e información son propiedad del proveedor del servicio.
    <br><br>
    Las tarifas están sujetas a cambio sin previo aviso.
    <br><br>
    El pago por concepto de depósito no es reembolsable.
    <br><br>
    Toda reservación debe ser pagada en su totalidad antes de tomar el servicio.
    <br><br>
    El pago por concepto de depósito (Cantidad mínima requerida para apartar los boletos) de las reservaciones para más de 10 personas debe ser pagado en su totalidad 15 días laborales antes de tomar el servicio.
    <br><br>
    Las reservaciones para más de 10 personas deben ser pagadas en su totalidad 3 días laborales antes de tomar el servicio.
    <br><br>
    Los planes de pago mensual son gestionados por la institución bancaria del usuario.
    <br><br>
    Exodus es un intermediario entre el cliente y el proveedor.
    <br><br>
    Exodus proporciona la plataforma web para solicitar reservaciones a los proveedores de servicios turísticos.
    <br><br>
    En caso de incidente, Exodus proporcionará la información y acompañamiento necesario para que el usuario se contacte con el proveedor del servicio en cuestión.
    <br><br>
    Las reservaciones sólo son válidas con el número de confirmación proporcionado por Exodus vía Facebook o sitio web oficial acompañado del comprobante de pago de la misma reservación.
    <br><br>
    Facebook oficial de Exodus: https://www.facebook.com/Exodus-M%C3%A9xico-691083214335683/
    <br>
    Sitio web oficial de Exodus: https://exodustickets.sistemy.mx/#/servicios
    <br><br>
    El comprobante de pago es emitido por PayPal para las reservaciones desde el sitio web oficial, si el pago es realizado vía transferencia bancaria o depósito bancario éste será emitido por el banco que lo procese. Si el cliente solicita el pago mensual vía Facebook oficial, éste será emitido por medio de Mercado Pago y será procesado por la institución bancaria pertinente.
    <br><br>
    Sitio oficial de mercado pago: https://www.mercadopago.com.mx/

    </div>
  </div>
  
  

 

<!-- </div> -->


</template>

<script>

import axios from 'axios';
import qs from 'qs';
import Cors from 'cors';
import moment from 'moment';
import {SnotifyPosition, SnotifyStyle} from 'vue-snotify';
import searchMix from '../mixins/mixin.js'
import DatePick from 'vue-date-pick'
import VueClockPicker from '@pencilpix/vue2-clock-picker'
import { Carousel3d, Slide } from 'vue-carousel-3d';

export default {
  components:{
    DatePick,
    VueClockPicker,
    Carousel3d,
    Slide
  },
  data () {
    return {
      

    }
  },
  created(){
    console.log("terminos",this.$route.path)
    
  },
  computed:{
  },
  methods:{
  },
  mixins: [searchMix]
}
</script>
